import { DependencyList, MutableRefObject, useEffect, useRef, useState } from 'react'
import { Subscription } from 'rxjs'
import { ReactState } from '../Types/Types'
import { RxJSState } from '../../../NonReact/common/Types/Types'

export const useRxJSMemo = <T extends unknown>(
    state: RxJSState<T>,
    factory: () => T,
    deps: Definable<DependencyList>
): T => {
    const [value, setValue]: ReactState<T> = useState<T>(factory())

    const subscription: MutableRefObject<Definable<Subscription>> = useRef<Definable<Subscription>>()

    useEffect((): void => {
        const factoryResult: T = factory()

        setValue(factoryResult)
        state.announce(factoryResult)
    }, deps)

    useEffect((): (() => void) => {
        subscription.current?.unsubscribe()
        subscription.current = state.observable.subscribe((data: T): void => setValue(data))

        return (): void => subscription.current?.unsubscribe()
    }, [state])

    return value
}
